import get from 'lodash/get';
import { handleActions } from 'redux-actions';
import type { Action } from '../actions';
import type { TopQuestionIdsType } from './index';
export const defaultState = ['cebf8f04-d650-4f74-a2a5-77038433e731'];
export default handleActions<TopQuestionIdsType, Action>({
  // @ts-expect-error todo(ts-migration) TS2322 Type '(state: TopQuestionIdsType, action: Action) => string[]' is not assignable to type 'ReducerMapValue<TopQuestionIdsType, Action>'.
  removeQuestion: (state: TopQuestionIdsType, action: Action) => {
    const questionId = get(action, 'payload.questionId');
    const nextState = [...state];
    return nextState.filter(id => id !== questionId);
  },
  // @ts-expect-error todo(ts-migration) TS2322 Type '(state: TopQuestionIdsType, action: Action) => any[]' is not assignable to type 'ReducerMapValue<TopQuestionIdsType, Action>'.
  addQuestion: (state: TopQuestionIdsType, action: Action) => {
    const parentId = get(action, 'payload.questionId');
    const newQuestion = get(action, 'payload.newQuestion');
    if (parentId) {
      // adding followup question
    } else {
      // adding top level question
      return [...state, newQuestion.id];
    }
    return state;
  }
}, []);